import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../features/auth/slices/auth.slice";
import productsReducer from "../features/products/slices/products.slice";
import chatReducer from "../features/chat/slices/chat.slice";
import requestsReducer from "../features/requests/slices/requests.slice";
import contactSupportReducer from "../features/contactSupport/slices/contactSupport.slice";
import myListingsReducer from "../features/myListings/slices/myListings.slice";
import sellerReducer from "../features/seller/slices/seller.slice";
import notificationsReducer from "../features/notifications/slices/notifications.slice";
import notificationPreferencesReducer from "../features/notificationPreferences/slices/notificationPreferences.slice";
import bookmarksReducer from "../features/bookmarks/slices/bookmarks.slice";
import blogReducer from "../features/blog/slices/blog.slice";
import assistantReducer from "../features/assistant/slices/assistant.slice";

const appReducer = combineReducers({
  auth: authReducer,
  products: productsReducer,
  chat: chatReducer,
  requests: requestsReducer,
  contactSupport: contactSupportReducer,
  myListings: myListingsReducer,
  seller: sellerReducer,
  notifications: notificationsReducer,
  notificationPreferences: notificationPreferencesReducer,
  bookmarks: bookmarksReducer,
  blog: blogReducer,
  assistant: assistantReducer,
});

const rootReducer = (state: any, action: any) => {
  // Clear all state on logout or when switching to visitor mode (if payload is true)
  if (
    action.type === "auth/logout" ||
    action.type === "auth/logoutUser/fulfilled" ||
    action.type === "auth/deleteAccount/fulfilled" ||
    (action.type === "auth/setVisitor/fulfilled" && action.payload === true)
  ) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
